import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { WhenModelValue, Form, ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import SalaryExports from 'pages/app/hr/salary/partials/SalaryExports'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { SecondaryHeading } from 'ui/headings'
import { Select } from 'support/fields'
import Button from 'ui/buttons/Button'

export default function SalaryOverviewSmartview () {
  return (
    <Translator namespace='smartviews.salary_overview'>
      <Smartview>
        <WhenModelValue name='id'>

          <SmartviewContentSection>
            <SecondaryHeading>
              <Displays.Text name='display_name' />
            </SecondaryHeading>
            <Form route='api.salary.salary_period.store'>
              <ExecuteOperationOnPipe namespace='api' resourceName='salary.salary_period' operationName='index' />
              <ExecuteOperationOnPipe namespace='api' resourceName='salary.salary_period' operationName='find' />

              <div className='space-y-4 pt-4'>
                <Select name='status' enum='salary_period_status'/>
                <Button type='submit'>
                  <Translation name='actions.update' />
                </Button>
              </div>
            </Form>
          </SmartviewContentSection>

          <SmartviewContentSeparator />

          <SmartviewContentSection>
            <SecondaryHeading>
              <Translation name='titles.downloads' />
            </SecondaryHeading>
            <SalaryExports />
          </SmartviewContentSection>

        </WhenModelValue>
      </Smartview>
    </Translator>
  )
}
